
const getObjAccordingToVoiceAndBackgroundMusic = (isBackgroundMusic) => {
    const musicSelectionObj = {
        'voice_selection' : {
            'heading': 'Voice Library',
            'subHeading': 'Please select voice for your series',
            'infoIconText': 'Voice Library has curated choice of voice for your series. Selected voice will be used to convert text to audio using AI tools.',
            'ctaText': 'Confirm Voice & Go To Music',
            'caution': 'Once voice selected, can’t be changed',
        },
        'background_music': {
            'heading': 'Background Music Library',
            'subHeading': 'Please select music for your series',
            'infoIconText': 'Background Music has curated choice of music for your series. We apply selected music on background of your audio series.',
            'ctaText': 'Confirm Music & Publish',
            'caution': 'Once music selected, can’t be changed',
        }
    }
    return isBackgroundMusic ? musicSelectionObj?.background_music:   musicSelectionObj?.voice_selection
}


const getSubText = (voice) => {
    const genre = voice.genre === 'all' ? ['any genre'] : (voice.genre).split(',')
    const subTxtArr = [...genre,voice.labels.gender,voice.labels.age,voice.labels.accent]
    const filteredArr = subTxtArr.filter((el) => el)
    return filteredArr.join(' | ')
}

export {
    getObjAccordingToVoiceAndBackgroundMusic ,
    getSubText
}